import Character from "./Character";

class Enemy extends Character {
  constructor(v) {
    super(v);
    this.drops = v.drops;
  }
}

export default Enemy;
